import { render, staticRenderFns } from "./MesaDelegacionesConsultas.vue?vue&type=template&id=3ca0017c"
import script from "./MesaDelegacionesConsultas.vue?vue&type=script&lang=js"
export * from "./MesaDelegacionesConsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports